import { PropsWithChildren } from "react"

export const OverlayBackgroundImage = ({
  className,
  children,
}: PropsWithChildren<{ className: string }>) => {
  return (
    <div
      className={`flex flex-1 items-center justify-center bg-contain bg-center bg-no-repeat ${className}`}
    >
      {children}
    </div>
  )
}
